import { render } from "./MatchReportForm.vue?vue&type=template&id=c57d8000"
import script from "./MatchReportForm.vue?vue&type=script&lang=js"
export * from "./MatchReportForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__